import GenerateCodeSetView from './GenerateCodeSetView'

export default GenerateCodeSetView
